
import Api from '../../api/api'
import { useScrollTrigger } from '@material-ui/core'

export const SETTING_CONST = {
    UPDATE_TAB_SELECT : "updTabSel",
    SET_DATAAPI_STATUS : "setDataapiStatus",
    SET_CALLAPI_STATUS : "setCallapiStatus",
    SET_NOTIFICATION_STATUS : "setNotificationStatus",

    CHANGE_TOKEN : "changeToken",
    SAVE_TOKEN : "saveToken",
    SET_TOKEN : "setToken",
    GET_TOKEN : "getToken",
    WAIT_SAVE_TOKEN : "waitSaveToken",
    CANCEL_TOKEN: "cancelToken",
    ERR_SAVE_TOKEN: "errSaveToken",
    DEFAULT_SAVE_TOKEN: "defaultSaveToken",

    SET_INTEGRATION : "setInegration",

    SET_URL: "setUrl",
    CHANGE_URL:"changeUrl",
    SAVE_LOGIN : "saveUrl",


    GET_URL : "getUrl",
    WAIT_SAVE_LOGIN : "waitSaveURL",
    CANCEL_URL: "cancelURL",
    ERR_SAVE_LOGIN: "errSaveURL",
    DEFAULT_SAVE_LOGIN: "defaultSaveURL",

    SET_UIS_ID: "setUisId",
    SET_ITEGRATION: "setIntegration",
    SET_INTEGRATION_ENABLE: "setIntegrationEnable",
    SET_AUTH: "setAuth",
    EXPANSION_PANEL_EXPANDED: "expansionPanel_expanded",
    STATE_POPUP: "statePopup",
    SET_ID_SALON: "SET_ID_SALON",
    CHANGE_ID_SALON: "CHANGE_ID_SALON",

    CHANGE_LOGIN: "CHANGE_LOGIN",
    CANCEL_LOGIN: "CANCEL_LOGIN",
    SET_LOGIN: "SET_LOGIN",
    ERR_SAVE_ID: "ERR_SAVE_ID",
    DEFAULT_SAVE_ID: "DEFAULT_SAVE_ID",
    WAIT_SAVE_ID: "WAIT_SAVE_ID",
    SAVE_ID: "SAVE_ID",
    CANCEL_ID: "CANCEL_ID",
}

export function selectTab(val){
    return {
        type: SETTING_CONST.UPDATE_TAB_SELECT,
        payload: val,
    }
}

export function changeInputLogin(text){
    return{
        type: SETTING_CONST.CHANGE_LOGIN,
        payload: text,
    }
}

export function setNotificationStatus(val){
    return {
        type: SETTING_CONST.SET_NOTIFICATION_STATUS,
        payload: val,
    }
}
export function changeToken(text){
    return{
        type: SETTING_CONST.CHANGE_TOKEN,
        payload: text,
    }
}
export function setToken(text){
    return{
        type: SETTING_CONST.SET_TOKEN,
        payload: text,
    }
}
export function saveToken(token, appId){ 
    function err(dispatch){
        dispatch({
            type: SETTING_CONST.ERR_SAVE_TOKEN,
        })
        setTimeout(() => dispatch({ type: SETTING_CONST.DEFAULT_SAVE_TOKEN }), 2000);
    }

    return dispatch => {
        dispatch({
            type: SETTING_CONST.WAIT_SAVE_TOKEN,
        })
        setTimeout(() =>
            Api.saveToken(token, appId)
                    .then(
                        (result)=>{
                            switch (result.status){
                                case 200:
                                    result.data.success? dispatch({ type: SETTING_CONST.SAVE_TOKEN }): err(dispatch);                                                           
                                    return;
                                default:
                                    err(dispatch);
                                    return;
                            }
                        }
                    ).catch(
                        (error)=>{
                            err(dispatch);
                            return;
                    }
                )
            , 1000); //задержка в 1 сек, чтобы пользователь успел увидеть текст что сохраняется 
    }
}

export function showPopup(anchor){
    return dispatch => {
        dispatch({
            type: SETTING_CONST.STATE_POPUP,
            payload: anchor
        })
        setTimeout(() => {
                dispatch({
                    type: SETTING_CONST.STATE_POPUP,
                    payload: null
                })
            }, 1000);
        }

}

export function cancelToken(){
    return{
        type: SETTING_CONST.CANCEL_TOKEN,
    }
}

export function setUisId(appId, customerId){
    return{
        type: SETTING_CONST.SET_UIS_ID,
        payload: {appId, customerId},
    }
}

export function setIntegration(status){
    return{
        type: SETTING_CONST.SET_INTEGRATION,
        payload: status,
    }
}

export function changeIntegration(status, appId, customerId, user, pass){
    return dispatch => {
        dispatch({
            type: SETTING_CONST.SET_INTEGRATION_ENABLE,
            payload: false,
        })
        Api.setIntegration(status, appId, customerId, user, pass)
            .then(
                (result)=>{
                    switch (result.status){
                        case 200:
                            if(!result.data.success){
                                dispatch({
                                    type: SETTING_CONST.SET_INTEGRATION,
                                    payload: !status,
                                });
                            }else{
                                dispatch({
                                    type: SETTING_CONST.SET_INTEGRATION,
                                    payload: status,
                                });
                            }

                            dispatch({
                                type: SETTING_CONST.SET_INTEGRATION_ENABLE,
                                payload: true,
                            })
                            return;
                        default:
                            dispatch({
                                type: SETTING_CONST.SET_INTEGRATION_ENABLE,
                                payload: true,
                            })
                            return;
                    }
                }
            ).catch(
                (err)=>{
                    dispatch({
                        type: SETTING_CONST.SET_INTEGRATION_ENABLE,
                        payload: true,
                    })
                }
            )
    }
}

export function setAuth(login, pass){
    return dispatch => {
        dispatch({
            type: SETTING_CONST.SET_AUTH,
            payload: {login, pass},            
        })
    }
}

export function toggleExpansionPanel(status = null){
    return{
        type: SETTING_CONST.EXPANSION_PANEL_EXPANDED,
        payload: status,
    }
}

export function setLogin(login){
    return dispatch => {
        dispatch({
            type: SETTING_CONST.SET_LOGIN,
            payload: login
        })
    }
}

export function saveLogin(url, appId){
    function err(dispatch){
        dispatch({
            type: SETTING_CONST.ERR_SAVE_LOGIN,
        })
        setTimeout(() => dispatch({ type: SETTING_CONST.DEFAULT_SAVE_LOGIN }), 2000);
    }
    return dispatch => {
        dispatch({
            type: SETTING_CONST.WAIT_SAVE_LOGIN,
        })
        setTimeout(() =>
            Api.saveLogin(url, appId)
                    .then(
                        (result)=>{
                            switch (result.status){
                                case 200:
                                    result.data.success? dispatch({ type: SETTING_CONST.SAVE_LOGIN }): err(dispatch);
                                    return;
                                default:
                                    err(dispatch);
                                    return;
                            }
                        }
                    ).catch(
                        (error)=>{
                            err(dispatch);
                            return;
                    }
                )
            , 1000); //задержка в 1 сек, чтобы пользователь успел увидеть текст что сохраняется 
    }
}

export function cancelLogin(){
    return dispatch => {
        dispatch({
            type:SETTING_CONST.CANCEL_LOGIN,
            payload: null
        })
    }
}

export function cancelID(){
    return dispatch => {
        dispatch({
            type:SETTING_CONST.CANCEL_ID,
            payload: null
        })
    }
}

export function setIdSalon(id){
    return dispatch => {
        dispatch({
            type: SETTING_CONST.SET_ID_SALON,
            payload: id
        })
    }
}

export function changeIdSalon(text){
    return{
        type: SETTING_CONST.CHANGE_ID_SALON,
        payload: text,
    }
}

export function saveId(id, appId){
    function err(dispatch){
        dispatch({
            type: SETTING_CONST.ERR_SAVE_ID,
        })
        setTimeout(() => dispatch({ type: SETTING_CONST.DEFAULT_SAVE_ID }), 2000);
    }
    return dispatch => {
        dispatch({
            type: SETTING_CONST.WAIT_SAVE_ID,
        })
        setTimeout(() =>
            Api.saveID(id, appId)
                    .then(
                        (result)=>{
                            switch (result.status){
                                case 200:
                                    result.data.success? dispatch({ type: SETTING_CONST.SAVE_ID }): err(dispatch);
                                    return;
                                default:
                                    err(dispatch);
                                    return;
                            }
                        }
                    ).catch(
                        (error)=>{
                            err(dispatch);
                            return;
                    }
                )
            , 1000); //задержка в 1 сек, чтобы пользователь успел увидеть текст что сохраняется
    }
}
